import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowRightIcon, BookOpenIcon, BuildingOffice2Icon, ClockIcon } from "@heroicons/react/24/outline";

export const UserGuideHub = () => {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = `${t("user_guide.hub.title")} | Promang`;
  }, [t]);

  return (
    <div className="min-h-screen bg-slate-50">
      <div className="mx-auto max-w-4xl px-4 py-8 sm:px-6 lg:px-8">
        <div className="mb-8 rounded-[2rem] border border-slate-200 bg-white px-6 py-6 shadow-sm">
          <div className="mb-3 inline-flex items-center gap-2 rounded-full bg-slate-100 px-3 py-1 text-xs font-semibold uppercase tracking-[0.18em] text-slate-600">
            <BookOpenIcon className="h-4 w-4" />
            {t("user_guide.hub.badge")}
          </div>
          <h1 className="text-3xl font-semibold tracking-tight text-slate-950">{t("user_guide.hub.title")}</h1>
          <p className="mt-2 max-w-2xl text-sm text-slate-600">{t("user_guide.hub.subtitle")}</p>
        </div>

        <div className="grid gap-4 sm:grid-cols-1">
          <Link
            to="/dashboard/guide/company"
            className="flex items-center justify-between gap-4 rounded-2xl border border-slate-200 bg-white px-5 py-4 shadow-sm transition hover:border-slate-300 hover:bg-slate-50"
          >
            <div className="flex min-w-0 items-center gap-4">
              <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-slate-100 text-slate-800">
                <BuildingOffice2Icon className="h-6 w-6" />
              </div>
              <div className="min-w-0">
                <div className="text-sm font-semibold text-slate-900">{t("user_guide.hub.card.company.title")}</div>
                <div className="text-xs text-slate-600">{t("user_guide.hub.card.company.description")}</div>
              </div>
            </div>
            <ArrowRightIcon className="h-5 w-5 shrink-0 text-slate-400" />
          </Link>
          <Link
            to="/dashboard/guide/hours"
            className="flex items-center justify-between gap-4 rounded-2xl border border-slate-200 bg-white px-5 py-4 shadow-sm transition hover:border-slate-300 hover:bg-slate-50"
          >
            <div className="flex min-w-0 items-center gap-4">
              <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-slate-100 text-slate-800">
                <ClockIcon className="h-6 w-6" />
              </div>
              <div className="min-w-0">
                <div className="text-sm font-semibold text-slate-900">{t("user_guide.hub.card.hours.title")}</div>
                <div className="text-xs text-slate-600">{t("user_guide.hub.card.hours.description")}</div>
              </div>
            </div>
            <ArrowRightIcon className="h-5 w-5 shrink-0 text-slate-400" />
          </Link>
        </div>

        <p className="mt-8 text-center text-xs text-slate-500">{t("user_guide.hub.footer_note")}</p>
      </div>
    </div>
  );
};
